//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LabeledControlLayout from '@/components/shared/labeled-control-layout'
import {mapActions} from 'vuex'

export default {
  name: 'UserRegistration',
  components: {LabeledControlLayout},
  data() {
    return {
      countries: [],
      registerForm: {
        data: {
          company: '',
          email: '',
          firstName: '',
          lastName: '',
          phone: '',
          billingAddress: '',
          billingCity: '',
          billingState: undefined,
          billingCountry: undefined,
          billingPostalCode: '',
          shippingSameAsBilling: true,
          shippingAddress: '',
          shippingCity: '',
          shippingState: undefined,
          shippingCountry: undefined,
          shippingPostalCode: '',
        },
        emailRules: [
          (v) => !!v || 'This is a required field.',
          (v) =>
            /.+@.+\..+/.test(v) ||
            this.$t('Please enter a valid email address'),
        ],
        rules: {
          required: (value) => !!value || 'This is a required field.',
          min: (v) => (v && v.length >= 8) || 'Min 8 characters',
        },
        showPassword: false,
        valid: false,
      },
    }
  },
  computed: {
    billingStates() {
      if (this.registerForm.data.billingCountry) {
        return this.$store.state.common.crm.territorialUnit.allStates.filter(
          (s) => s.parentId === this.registerForm.data.billingCountry.value
        )
      }
      return []
    },
    shippingStates() {
      if (this.registerForm.data.shippingCountry) {
        return this.$store.state.common.crm.territorialUnit.allStates.filter(
          (s) => s.parentId === this.registerForm.data.shippingCountry.value
        )
      }
      return []
    },
  },
  async mounted() {
    this.countries = await this.fetchCountries()
    await this.fetchAllStates()

    try {
      await this.$recaptcha.init()
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    ...mapActions('common/crm/territorialUnit', [
      'fetchCountries',
      'fetchAllStates',
    ]),
    onBillingCountryChanged(v) {
      if (typeof v === 'string' || v instanceof String) {
        this.registerForm.data.billingCountry = this.countries.find(
          (x) => x.text === v
        )
      }
      this.registerForm.data.billingState = null
    },
    onShippingCountryChanged(v) {
      if (typeof v === 'string' || v instanceof String) {
        this.registerForm.data.shippingCountry = this.countries.find(
          (x) => x.text === v
        )
      }
      this.registerForm.data.shippingState = null
    },
    async register() {
      if (this.$refs.registerForm.validate()) {
        const captchaResult = await this.checkIfUserIsHuman('register')
        if (!captchaResult.success || captchaResult.score < 0.5) {
          return
        }
        try {
          const data = {
            Email: this.registerForm.data.email,
            Company: this.registerForm.data.company,
            FirstName: this.registerForm.data.firstName,
            LastName: this.registerForm.data.lastName,
            Phone: this.registerForm.data.phone,
            BillingAddress: this.registerForm.data.billingAddress,
            BillingCity: this.registerForm.data.billingCity,
            BillingPostalCode: this.registerForm.data.billingPostalCode,
            BillingStateID: this.registerForm.data.billingState
              ? this.registerForm.data.billingState.value
              : null,
            BillingCountryID: this.registerForm.data.billingCountry
              ? this.registerForm.data.billingCountry.value
              : null,
            ShippingSameAsBilling: this.registerForm.data.shippingSameAsBilling,
          }
          if (!this.registerForm.data.shippingSameAsBilling) {
            data.ShippingAddress = this.registerForm.data.shippingAddress
            data.ShippingPostalCode = this.registerForm.data.shippingPostalCode
            data.ShippingCity = this.registerForm.data.shippingCity
            data.ShippingStateID = this.registerForm.data.shippingState
              ? this.registerForm.data.shippingState.value
              : null
            data.ShippingCountryID = this.registerForm.data.shippingCountry
              ? this.registerForm.data.shippingCountry.value
              : null
          }

          const response = await this.$axios.post(
            'auth/frontend-register',
            data
          )
          if (response.status === 200) {
            if (response.data.hasErrors === true) {
              const errors = response.data.errorMessages
              for (const key in errors) {
                if (errors.hasOwnProperty(key)) {
                  this.$toast.error(errors[key])
                }
              }
            } else {
              this.$toast.success(
                'User successfully registered! Your registration will be reviewed shortly.'
              )
              await this.$router.push('user-login')
            }
          } else {
            this.$toast.error(
              'There was an error registering the user! Error code: ' +
                response.status
            )
          }
        } catch (err) {
          this.$toast.error('There was an error registering the user!')
        }
      }
    },
    async checkIfUserIsHuman(actionType) {
      let googleResult = ''
      try {
        const token = await this.$recaptcha.execute(actionType)
        await this.$axios
          .$get(`/recaptcha-handler`, {
            params: {
              googleToken: token,
            },
          })
          .then((res) => {
            googleResult = JSON.parse(res)
          })
      } catch (e) {
        console.log(e)
      }
      return googleResult
    },
  },
  beforeDestroy() {
    this.$recaptcha.destroy()
  },
}
